exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-content{border-radius:4px}.detail-content .detail-form,.detail-content .input-with-date,.detail-content .input-with-date input{width:100%}.detail-content .detail-form h5{margin:0 0 20px}.detail-content .detail-form h5 span{margin:0;font-weight:700;letter-spacing:1px;text-transform:uppercase;border-bottom:1px solid;padding:0 4px}.detail-content .detail-form .form-group{margin-top:15px}.detail-content div{background:#fff;padding:10px 30px}.detail-content div div{padding:0}.detail-content div div p{text-align:left;font-weight:700}.detail-content div div p span{font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07f04a4e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/payment/detailPayment/detailPayment.vue
// module id = 1077
// module chunks = 0